import { render, staticRenderFns } from "./UserManagementView.vue?vue&type=template&id=234b0b75&scoped=true"
import script from "./UserManagementView.vue?vue&type=script&lang=js"
export * from "./UserManagementView.vue?vue&type=script&lang=js"
import style0 from "./UserManagementView.vue?vue&type=style&index=0&id=234b0b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b0b75",
  null
  
)

export default component.exports